import React, { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";

export const SearchBar = ({ onSearch, width = "250px", height = "42px" }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearch(value);
  };

  return (
    <div
      className="flex items-center border border-gray-300 rounded-md px-2 focus-within:border-blue-500"
      style={{ width, height }}
    >
      <SearchOutlined className="text-gray-500 text-lg" />
      <input
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={handleSearchChange}
        className="w-full outline-none border-none p-2 text-base font-light"
      />
    </div>
  );
};

export default SearchBar;
